/* ── Mobile menu toggle ── */
(function () {
  const toggle = document.getElementById('mobile-menu-toggle');
  const menu   = document.getElementById('mobile-menu');
  const iconMenu  = document.getElementById('icon-menu');
  const iconClose = document.getElementById('icon-close');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('hidden') === false;
    toggle.setAttribute('aria-expanded', open);
    iconMenu.classList.toggle('hidden', open);
    iconClose.classList.toggle('hidden', !open);
  });
})();

/* ── Add to cart ── */
(function () {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-atc');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) {
        // Shopify's 422 body carries the shopper-readable reason — usually
        // "You can only add N of X to the cart". Don't swallow it.
        const body = await res.json().catch(() => null);
        throw new Error(window.TTT ? TTT.cart.error(body) : 'Cart error');
      }
      if (window.TTT) TTT.cart.refresh();

      btn.textContent = 'Added ✓';
      btn.classList.replace('bg-gold', 'bg-green-600');

      setTimeout(() => {
        btn.textContent = 'Add to cart';
        btn.classList.replace('bg-green-600', 'bg-gold');
        btn.disabled = false;
      }, 2000);
    } catch (err) {
      btn.textContent = 'Try again';
      btn.disabled = false;
      if (window.toast) toast(err && err.message ? err.message : 'Could not add to cart', 'error');
    }
  });
})();

/* ── Shop category pill filter ── */
(function () {
  const filters  = document.getElementById('shop-filters');
  if (!filters) return;

  filters.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-filter]');
    if (!pill) return;

    filters.querySelectorAll('[data-filter]').forEach(p => {
      p.classList.remove('pill-active', 'bg-ink', 'text-cream', 'border-ink');
      p.classList.add('border-line');
    });
    pill.classList.add('pill-active');
    pill.classList.remove('border-line');
  });
})();

/* ── Reveal animation observer ── */
(function () {
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  document.querySelectorAll('.reveal').forEach((el) => {
    el.style.animationPlayState = 'paused';
    observer.observe(el);
  });
})();
